import dayjs from "dayjs";

export const checkIsChristmas = (): boolean => {
  const currentMonth = dayjs().get("month");
  const currentDay = dayjs().get("date");

  if (currentMonth === 0 && currentDay <= 5) return true;
  if (currentMonth === 11 && currentDay >= 8) return true;

  return false;
};

export const formatDate = (date: string) => {
  return dayjs(date).format("YYYY-MM-DD HH:mm");
};

export const parseNumberFromLocaleString = (number: string) => {
  return parseInt(number.replace(/,/g, ""));
};

export const getCurrencySymbol = (currency: string) =>
  (0)
    .toLocaleString("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
